<div class="transit-location">
  <location-ingot [location]="origin"></location-ingot>
</div>

<icon type="arrow-right"></icon>

<div class="transit-location">
  <location-ingot [location]="destination"></location-ingot>
</div>
